// src/services/authService.js
import api from "../api/api";

// Fungsi login: kirim email & password, ambil token dari response
export const login = async ({ email, password }) => {
  try {
    const response = await api.post("/auth/login", { email, password });

    const token = response.data?.data?.token;
    if (token) {
      localStorage.setItem("token", token);
    }

    return response.data; // { statusCode, data: { token }, message, success }
  } catch (error) {
    throw error;
  }
};

// Fungsi ambil data profil user
export const getUserProfile = async () => {
  try {
    const response = await api.get("/auth/me");
    return response.data?.data; // sesuaikan sesuai struktur backend
  } catch (error) {
    throw error;
  }
};

// Fungsi logout: token dikirim otomatis lewat interceptor
export const logout = async () => {
  try {
    const response = await api.post("/auth/logout");
    localStorage.removeItem("token");
    return response.data;
  } catch (error) {
    throw error;
  }
};
